import { Component } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager/google-tag-manager.service';

@Component({
  selector: 'app-google-tag-manager',
  template: '',
  styleUrls: [],
  providers: [GoogleTagManagerService]
})
export class GoogleTagManagerComponent {
  constructor(private googleTagManagerService: GoogleTagManagerService) { }
}
